import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

import { TripFull } from '@/models/trip'

import { formatKeysForTable } from '@/helpers/data-table'
import { getTripExtrasPostfix, getTripKeyMeta } from '@/helpers/trip'
import { centsToDollars, commonCase } from '@/helpers/strings'


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceBreakDownSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

////////////////
const localFormatKeysForTable = (
  trip: TripFull | null,
  keys: (keyof TripFull)[]
) => {
  if (!trip) {
    return []
  }

  return keys.map(key => {
    let value = trip[key]
    // Check if the key is 'admin_profit' and divide by 100 if it is
    if (key === 'admin_profit' && typeof value === 'number') {
      value = value / 100
    }
    // Check if the key is 'effective_admin_fee' and multiply by 100 if it is
    if (key === 'effective_admin_fee' && typeof value === 'number') {
      value = value * 100
    }
    // Check if the key is 'admin_profit' or 'pickup_address_price' or 'dropoff_address_price' and divide by 100 if it is
    if (
      (key === 'admin_profit' ||
        key === 'pickup_address_price' ||
        key === 'dropoff_address_price') &&
      typeof value === 'number'
    ) {
      value = value / 100
    }

    return {
      key,
      value,
      label: commonCase(key, true),
    }
  })
}
////////////////

const dataArray = computed(() => {
  return localFormatKeysForTable(props.trip, [
    // return formatKeysForTable(props.trip, [
    'rental_fee',
    'rent_duration',
    'admin_fee',
    'effective_admin_fee',
    'host_profit',
    'admin_profit',
    'total_insurance',
    'deposit',
    'promotional_admin_fee',
    'pickup_address_price',
    'dropoff_address_price',
  ])
})

const getLabelByKey = (label: string, key: string) => {
  if (key === 'total_insurance') {
    return commonCase('insurance_fee', true)
  }
  return label
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "title" }, "Price breakdown section", -1)),
    _createVNode(_component_el_descriptions, {
      border: "",
      column: 2,
      direction: "vertical",
      class: "description-container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_descriptions_item, {
            key: item.key,
            width: "50%"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByKey(item.label, item.key)) + " " + _toDisplayString(_unref(getTripKeyMeta)(item.key).postfix), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 19 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getTripKeyMeta)(item.key).isPriceKey
              ? _unref(centsToDollars)(Number(item.value) ?? 0)
              : item.value), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (item.key === 'promotional_admin_fee')
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 5
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Accepted: " + _toDisplayString(Boolean(_ctx.trip?.is_promotional_admin_fee)), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (_ctx.trip.extras_json && _ctx.trip.extras_json.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.trip.extras_json, (item) => {
              return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: item.name,
                width: "50%"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(commonCase)(item.name, true)) + " " + _toDisplayString(_unref(getTripExtrasPostfix)(item.name)), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_unref(centsToDollars)(item.fee)), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true),
        _createVNode(_component_el_descriptions_item, {
          className: "total-item",
          width: "50%"
        }, {
          label: _withCtx(() => [
            _createTextVNode(" Total " + _toDisplayString(_unref(getTripKeyMeta)('total').postfix), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref(centsToDollars)(_ctx.trip.total)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})